import { Injectable, signal } from '@angular/core';
import { MapListing } from '../models/map-listing.model';

interface MapListingsResponse {
  listings: MapListing[];
  generated_at: string;
}

@Injectable({ providedIn: 'root' })
export class ListingsService {
  // Currently visible pins (narrowed by the active map filter).
  readonly listings = signal<MapListing[]>([]);
  // Full unfiltered set, populated by the initial/unfiltered fetch. The plan
  // resolves its stops from this so filtering the map never drops plan stops.
  readonly allListings = signal<MapListing[]>([]);
  readonly loading = signal(false);
  readonly error = signal<string | null>(null);

  async fetchMapListings(query = ''): Promise<void> {
    this.loading.set(true);
    this.error.set(null);
    try {
      const res = await fetch(`/api/v1/listings/map${query}`, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const body = (await res.json()) as MapListingsResponse;
      this.listings.set(body.listings);
      // Unfiltered fetches (initial load and reset) refresh the full set.
      if (!query) this.allListings.set(body.listings);
    } catch (e) {
      this.error.set(e instanceof Error ? e.message : 'Unknown error');
    } finally {
      this.loading.set(false);
    }
  }
}
